var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1670_512)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#E2E2E2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3257 17L24.2254 11.1003C24.3961 10.9235 24.4906 10.6866 24.4885 10.4408C24.4864 10.195 24.3878 9.95988 24.2139 9.78606C24.0401 9.61224 23.805 9.51365 23.5592 9.51151C23.3134 9.50937 23.0765 9.60387 22.8997 9.77464L17 15.6743L11.1004 9.77464C10.9235 9.60387 10.6867 9.50937 10.4409 9.51151C10.1951 9.51365 9.95997 9.61224 9.78615 9.78606C9.61233 9.95988 9.51374 10.195 9.5116 10.4408C9.50947 10.6866 9.60396 10.9235 9.77473 11.1003L15.6744 17L9.77473 22.8996C9.68519 22.9861 9.61377 23.0896 9.56464 23.204C9.5155 23.3183 9.48964 23.4413 9.48856 23.5658C9.48748 23.6903 9.5112 23.8138 9.55834 23.929C9.60548 24.0442 9.67509 24.1489 9.76311 24.2369C9.85114 24.3249 9.95581 24.3945 10.071 24.4417C10.1862 24.4888 10.3097 24.5125 10.4342 24.5114C10.5587 24.5104 10.6817 24.4845 10.796 24.4354C10.9104 24.3862 11.0139 24.3148 11.1004 24.2253L17 18.3256L22.8997 24.2253C23.0765 24.396 23.3134 24.4905 23.5592 24.4884C23.805 24.4863 24.0401 24.3877 24.2139 24.2138C24.3878 24.04 24.4864 23.8049 24.4885 23.5591C24.4906 23.3133 24.3961 23.0765 24.2254 22.8996L18.3257 17Z",
    fill: "#828282"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1670_512",
    x: -12,
    y: -12,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1670_512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1670_512",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.82e0fc5baefe2c298a2c8bc7c4cf11da.svg";
export { ForwardRef as ReactComponent };